import SettingsCard from '../settings_card'
import LocalizableLabels from './localizable_labels'
import CommonValues from './common_values'

const Items = ({ collection, schema, disabled, cycleID, airlineID }) => {
  return (
    <SettingsCard
      title='Items'
      description='Values in this list.'
      contentClassName='flex w-full flex-col gap-4 rounded-2xl border border-[color:var(--cs-color-border-default)] bg-[var(--cs-color-background-primary)] px-5 pb-5 pt-2'
    >
      {collection?.is_localizable ? (
        <LocalizableLabels
          collection={collection}
          schema={schema}
          cycleID={cycleID}
          airlineID={airlineID}
          disabled={disabled}
        />
      ) : (
        <CommonValues collection={collection} disabled={disabled} cycleID={cycleID} />
      )}
    </SettingsCard>
  )
}

export default Items
